<template>
  <div class="plpkp" style="height: 100%; width: 208px; background-color: rgba(52, 57, 64, 1);"
    :style="{ width: pd ? '208px' : 'auto' }">
    <div class="menu-content" :style="{ width: !pd ? '100%' : '208px' }">
      <ul class="w_nav" v-for="item in nav_list" :key="item.MenuID"
        v-bind:class="{ Menu_Selected: selectedPath === item.LinkURL || pselectedMenuID === item.MenuID, actives: isActive, 'text-danger': hasError, }">
        <li @click.stop="gourl(item)">
          <i :class="item.Icon"></i>
          <span v-if="pd">{{ item.MenuName }}</span>
          <em v-if="item.children" class="el-icon-arrow-right"></em>
          <ul class="w_two" v-if="item.children">
            <li v-for="items in item.children" :key="items.MenuID"
              v-bind:class="{ Menu_Selected: selectedPath === items.LinkURL, actives: isActive, 'text-danger': hasError, }"
              @click.stop="gourl(items)">
              {{ items.MenuName }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      RoleID:sessionStorage.getItem('RoleID'),
      PMenuID: '',
      isCollapse: true,
      logo: process.env.VUE_APP_URLs + 'File/PMS/logo/systemwhite.png',
      dee: sessionStorage.getItem('dee'),
      title: '北辰心理',
      pd: true,
      pselectedMenuID: '',
      selectedPath: sessionStorage.getItem('SelectPath') &&
        sessionStorage.getItem('SelectPath') != ''
        ? sessionStorage.getItem('SelectPath') : '',
      isActive: true,
      hasError: false,
      nav_list: [],
    }
  },
  methods: {
    handleOpen(key, keyPath) { },
    handleClose(key, keyPath) { },
    change() {
      this.pd = false
      this.isActive = false
      this.hasError = true
    },
    change1() {
      this.pd = true
      this.isActive = true
      this.hasError = false
    },
    gourl(obj) {
      if (!(
        obj.children != undefined &&
        obj.children != null &&
        obj.children.length > 0
      )
      ) {
        this.selectedPath = obj.LinkURL
        this.$router.push(obj.LinkURL)
      }
    },
    LoadMenu(PID) {
      let _this = this
      this.$Http_Post('User/GetRoleMenu', { PMenuID: PID ,RoleID:this.RoleID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.nav_list = res.Data
          if (_this.nav_list.length > 0) {
            _this.selectedPath = _this.nav_list[0].LinkURL
            this.$router.push(_this.selectedPath)
          }
        }else if(res.Code==208){
          this.$router.push('/login');
        }
      });
    },
    SetPMenuID(PID) {
      this.PMenuID = PID
      this.LoadMenu(PID)
    }
  },
  watch: {
    //监听
    $route() {
      let Object = {
        path: this['$route'].path,
        title: this['$route'].meta.title,
        name: this['$route'].name,
      }
      this.pselectedMenuID = ''
      this.selectedPath = Object.path
      for (let i = 0; i < this.nav_list.length; i++) {
        if (this.nav_list[i].LinkURL.indexOf(this.selectedPath) > -1) {
          this.selectedPath = this.nav_list[i].LinkURL
          break
        }
        if (this.nav_list[i].children && this.nav_list[i].children.length > 0) {
          for (let j = 0; j < this.nav_list[i].children.length; j++) {
            if (this.nav_list[i].children[j].LinkURL.indexOf(this.selectedPath) > -1) {
              this.pselectedMenuID = this.nav_list[i].MenuID
              this.selectedPath = this.nav_list[i].LinkURL
              break
            }
          }
          if (this.pselectedMenuID != '') break
        }
      }
    },
  },
}
</script>
<style>
.plpkp {
  float: left;
}

.report-content {
  height: 100%;
  width: calc(100% - 208px);
  float: right;
}

.Menu_Selected {
  background-color: #409eff !important;
}

.w_nav>li {
  height: 52px;
  border-bottom: 1px solid #444444;
  line-height: 52px;
  font-size: 14px;
  color: #fff;
  position: relative;
}

.w_nav>li span {
  position: absolute;
  left: 46px;
}

.w_nav>li em {
  position: absolute;
  right: 20px;
  top: 20px;
}

.w_nav>li:nth-child(1) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -20px;
  position: absolute;
  left: 16px;
  font-size: 18px;
  top: 0px;
}

.w_nav>li:nth-child(2) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -40px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(3) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -60px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(4) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -80px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(5) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -100px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(6) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -120px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(7) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -140px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(8) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -160px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(9) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -180px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(10) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -200px;
  position: absolute;
  top: 15px;
  left: 16px;
}

.w_nav li:hover {
  background-color: #66BFFF;
  cursor: pointer;
}

.w_nav li:hover ul {
  display: block;
}
</style>
